import React, { Component } from "react";
import { getUserInfo, deleteAccount } from "../../services/api";
import Auth from "../../services/auth";

class MobileDeleteAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
      errorMessage: null,
    };
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    this.setState({ deleting: true });
    deleteAccount()
      .then(() => {
        Auth.logout();
      })
      .catch(() => {
        this.setState({ deleting: false, errorMessage: "Something went wrong." });
      });
  }

  render() {
    const { history } = this.props;
    const userInfo = getUserInfo() || {};
    const metadata = userInfo.user_metadata || {};
    const firstname =
      metadata.customFirstname ||
      userInfo.username ||
      userInfo.given_name ||
      userInfo.nickname ||
      "";
    const email = metadata.customEmail || userInfo.email || "";
    const { deleting, errorMessage } = this.state;

    return (
      <div id="account-menu-container">
        <div className="one column row links overview">
          <div className="left aligned column overview">
            First Name: <b>{firstname}</b>
          </div>
          <div className="left aligned column overview">
            Email: <b>{email}</b>
          </div>
        </div>
        <div className="one column row links overview-btn" style={{ textAlign: "center" }}>
          {errorMessage ? (
            <b>{errorMessage}</b>
          ) : deleting ? (
            <b>Deleting Account...</b>
          ) : (
            <b>Are you sure you want to delete your account?</b>
          )}
        </div>
        <div className="one column row links overview-btn">
          <div className="center aligned column">
            <button
              className="ui fluid primary button overview"
              style={{ background: "rgba(30,93,186,1)", color: "white" }}
              onClick={this.handleDelete}
              disabled={deleting}
            >
              DELETE
            </button>
          </div>
          <div className="center aligned column">
            <button
              className="ui fluid primary button overview"
              onClick={() => history.push("/account?screen=overview")}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default MobileDeleteAccount;
